import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AlertTriangle, X } from "lucide-react";
import { axios, API } from "../lib/api";
import { useAuth } from "../auth/AuthProvider";

export const TrialEndingBanner = () => {
  const { user, token } = useAuth();
  const navigate = useNavigate();
  const [sub, setSub] = useState(null);
  const [dismissed, setDismissed] = useState(() => sessionStorage.getItem("trial_banner_dismissed") === "1");

  useEffect(() => {
    if (!token) { setSub(null); return undefined; }
    let cancelled = false;
    axios.get(`${API}/subscriptions/me`, { headers: { Authorization: `Bearer ${token}` } })
      .then(res => { if (!cancelled) setSub(res.data); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, [token]);

  if (!user || !sub?.is_trial || !sub?.expires_at || dismissed) return null;
  const expiresAt = new Date(sub.expires_at);
  const msLeft = expiresAt.getTime() - Date.now();
  const daysLeft = Math.ceil(msLeft / (1000 * 60 * 60 * 24));
  if (daysLeft > 2 || daysLeft < 0) return null;

  const dismiss = () => {
    sessionStorage.setItem("trial_banner_dismissed", "1");
    setDismissed(true);
  };

  const getBannerMessage = () => {
    if (daysLeft <= 0) return "Your Pro trial ends today!";
    if (daysLeft === 1) return "Your Pro trial ends tomorrow.";
    return `Only ${daysLeft} days left in your Pro trial.`;
  };

  return (
    <div
      data-testid="trial-ending-banner"
      className="sticky top-0 z-40 bg-[#FF6B6B] border-b-4 border-gray-900 text-white"
    >
      <div className="max-w-7xl mx-auto px-6 py-2 flex items-center justify-between gap-3">
        <div className="flex items-center gap-2 text-sm font-bold">
          <AlertTriangle className="w-4 h-4 flex-shrink-0" />
          <span>
            {getBannerMessage()}
            <span className="hidden sm:inline"> Keep your benefits — upgrade now.</span>
          </span>
        </div>
        <div className="flex items-center gap-2">
          <button
            onClick={() => navigate("/pricing")}
            data-testid="trial-banner-upgrade"
            className="bg-white text-[#FF6B6B] text-xs font-black px-3 py-1.5 rounded-full border-2 border-gray-900 hover:bg-gray-100"
          >
            Upgrade
          </button>
          <button
            onClick={dismiss}
            data-testid="trial-banner-dismiss"
            aria-label="Dismiss"
            className="p-1 hover:bg-white/20 rounded-full"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
};
